import { DatePipe } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ModalDismissReasons, NgbModal, NgbPopover, NgbPopoverConfig } from "@ng-bootstrap/ng-bootstrap";
import { CsAgentAuthService } from "@spartacus/asm/root";
// import { ActiveCartService } from "@spartacus/cart/base/core";
import { AuthService, BaseSiteService, CmsService, GlobalMessageService, GlobalMessageType, OccEndpointsService, RoutingService } from "@spartacus/core";
import { UserAccountFacade } from "@spartacus/user/account/root";
import * as moment from 'moment';
import { defineLocale, enGbLocale } from "ngx-bootstrap/chronos";
import { BsLocaleService } from "ngx-bootstrap/datepicker";
import { Subscription } from "rxjs";
import { filter, take } from "rxjs/operators";
import { CustomAddToCartService } from "src/app/custom-add-to-cart/custom-add-to-cart.service";
import { ProductDetailsComponent } from "src/app/custom-add-to-cart/custom-add-to-cart/product-details/product-details.component";
import { CustomProdPgService } from "src/app/custom-prod-pg/custom-prod-pg.service";
import { BaseService } from "src/app/shared/services/base.service";
import { DataLayerService } from 'src/app/shared/services/data-layer.service';
import { SharedService } from "src/app/shared/services/shared.service";
import { NumberSix, NumberTen, NumberThree } from "src/app/shared/utils/constants/global.constants";
import { ProductUtils } from "src/app/shared/utils/productUtils";
import * as _ from 'underscore';
import * as config from '../../../app/shared/config/app.config';
import {
  otherDiscounts,
  saleTax
} from '../../shared/utils/constants/global.constants';

@Component({
  selector: 'app-checkout-module',
  templateUrl: './checkout-module.component.html',
  styleUrls: ['./checkout-module.component.scss'],
})
export class CheckoutModuleComponent implements OnInit, OnDestroy {
  headerLevelObj: any;
  deliveryPickup: string = 'delivery';
  isSticky: boolean = false;
  emailErrorMsg: boolean = false;
  phoneErrorMsg: boolean = true;
  orderByErrorMsg: boolean = false;
  EmailforContact: any;
  contactDetails2: any;
  isaddnewemailadded: any;
  selectedPaymentMethodDetails: any;
  selectedCardOrAccountDetails: any;
  emailFinalArr: any = [];
  mobFinalArr: any = [];
  shipToArr: any = [];
  lastcarddigit: any;
  paymentMethod: any;
  faxErrorMsg: boolean = true;
  ErrMsg = 'Please select a valid Email address';
  mobileErrorMsg: boolean = true;
  contactDetails: any;
  contactDetailsSub: any;
  phoneNo: any;
  mobileNo: any;
  faxValid: boolean = true;
  cMethodVal: boolean = true;
  public productInfo: {
    available: boolean;
    availabilityText: string;
    batchInfo: {
      batchNumber: string;
      expiryDate: string;
      quantity: number;
    };
    images: any;
    code: string;

    description: string;
    discontinued: boolean;
    sapAllocation: boolean;
    displayProduct: boolean;
    flu: boolean;
    nameHtml: any;
    summary: any;

    productUpdate: string;
    productDocuments: {
      productDocument: [
        {
          url: string;
        }
      ];
    };
    name: string;
    orderable: boolean;
    quantityPerUnit: number;
    productUpdates: string;
    productDocument: any;
    volumePrices: [
      {
        currencyIso: string;
        formattedValue: string;
        maxQuantity: string;
        minQuantity: string;
        priceType: string;
        value: string;
      }
    ];
    url: string;
    stock: {
      isValueRounded: boolean;
    };
    isValueRounded: boolean;
    yellowFever: boolean;
    volumePricesFlag: boolean;
  } = null;
  standardCartDetails: any;
  productEntries: any = [];
  public images: any;
  updateTotal: boolean;
  updateEntriesData: any = [];
  subTotal: number;
  baseUrl: string;
  minDeliveryDate = new Date();
  maxDeliveryDate = new Date();
  minPickupDate = new Date();
  maxPickupDate = new Date();
  currentTime = new Date().getHours();
  pickupTimeFormat: any = [];
  timeFormat: any;
  selectedTime: any;
  deliveryDate: Date;
  deliveryCrossIcon: boolean;
  pickupDate: Date;
  deliveryDateFormat: string;
  pickupDateFormat: string;
  pickupCrossIcon: boolean;
  fallbackImage = '../../assets/i18n-assets/sanofi_missing_product.jpg';
  closeResult = '';
  usergetDataObj: any;
  getuserData: any;
  searchedClientList: any;
  selectedData: any;
  listSelectedData: any;
  userAccountgetData: any;
  saveCartName: string;
  popoverConfig: NgbPopoverConfig;
  cartId: any;
  errorMsg: string;
  deleteSuccess: string;
  addSuccess = false;
  cartItems: any;
  totalSavings = 0.0;
  subTotalVal = 0.0;
  totalWithPromtPayDiscountSum = 0.0;
  finalSaving = 0.0;
  changeLocation = false;
  templatePage: any;
  prodAddedSub: Subscription;
  cartItemsSub: Subscription;
  removeEntriesSub: Subscription;
  deleteCartSub: Subscription;
  cartDetailsSub: Subscription;
  checkoutDetailsSub: Subscription;
  checkoutFailedSub: Subscription;
  userAccountDetailsSub: Subscription;
  changedLocSub: Subscription;
  saveCartInvalidSub: Subscription;
  saveCartSuccessSub: Subscription;
  plpMiniCartSub: Subscription;
  userDataSub: Subscription;
  emailArr = [{ id: null, value: '', iserror: false, itemValue: '' }];
  emailList = [
    { id: '1', value: 'test@12.com' },
    { id: '2', value: 'test@1234562.com' },
  ];
  mobileList = [{ value: '', iserror: false }];
  emailArrCopy = [];
  noshowaddmobile: boolean = false;
  noshowaddemail: boolean = false;
  @ViewChild('p2') public savePopover: NgbPopover;
  orderBlock = false;
  showDangerAlert = false;
  checkoutClicked = false;
  checkoutCartClicked = false;
  yfEntry = false;
  urlPath: string;
  localSubscription: any;
  panelProductExpanded2 = false;
  panelProductExpanded = true;
  b2bUnitId: any;
  b2b: any;
  cartProdDetails: Subscription;
  expandedItems: boolean[] = [];
  stdCartDetails: any;
  orderContactDetails: any;
  payerAddress: any;
  checkoutCartDetailsSub: Subscription;
  checkoutCartFailedSub: Subscription;
  baseSiteId: string;
  isFutershipAdded = false;
  punchoutCheckout: boolean = false;
  punchoutId: string;
  punchoutCheckoutData: any;
  pdfUrl: any;
  error_message_dating: string;
  buyer_form_post_url: any;
  xml: any;
  showFax: boolean = true;
  isAsmUser: boolean = false;
  csAgentAuthSubscription: Subscription;
  punchOutKey: boolean;
  //After upgrade ActiveCartService causing - NullInjectorError: R3InjectorError(AppModule)[ActiveCartService -> ActiveCartService -> ActiveCartService]
  otherDiscountsFlag: string;
  salesTaxFlag: string;
  constructor(
    protected modal: NgbModal,
    private readonly baseService: BaseService,
    // private readonly getCart: ActiveCartService,
    private readonly cdr: ChangeDetectorRef,
    private readonly addToCart: CustomAddToCartService,
    readonly user: UserAccountFacade,
    private readonly modalService: NgbModal,
    private localeService: BsLocaleService,
    public datepipe: DatePipe,
    private readonly config: NgbPopoverConfig,
    private readonly route: RoutingService,
    private readonly occEndPoint: OccEndpointsService,
    private readonly plpService: CustomProdPgService,
    private globalMessage: GlobalMessageService,
    private readonly pageDate: CmsService,
    private readonly sharedService: SharedService,
    private readonly routeService: ActivatedRoute,
    private readonly authService: AuthService,
    private baseSiteService: BaseSiteService,
    private readonly csAgentAuthService: CsAgentAuthService,
    private readonly http: HttpClient,
    private router: Router,
    private _dataService: DataLayerService
  ) {
    this.images = {};
    this.updateTotal = false;
    enGbLocale.weekdaysShort = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
    enGbLocale.week.dow = 0;
    defineLocale('en-gb', enGbLocale);
    this.localeService.use('en-gb');
    this.pickupTimeFormat = [
      '09:00 am',
      '10:00 am',
      '11:00 am',
      '12:00 pm',
      '01:00 pm',
      '02:00 pm',
      '03:00 pm',
      '04:00 pm',
      '05:00 pm',
    ];
    this.selectedTime = null;
    config.autoClose = 'outside';
    this.deleteSuccess = '';
    this.addSuccess = false;
    this.baseSiteService
      .getActive()
      .pipe(take(1))
      .subscribe((res) => (this.baseSiteId = res));
  }
  @HostListener('window:scroll', ['$event'])
  checkScroll() {
    if (window.pageYOffset >= 150) {
      this.isSticky = true;
    } else {
      this.isSticky = false;
    }
    //this.isSticky = window.pageYOffset >= 400;
  }

  redirectToCart() {
    this.route.goByUrl("/cart");
  }

  ngOnInit(): void {
    this.otherDiscountsFlag = otherDiscounts;
    this.salesTaxFlag = saleTax;
    if (localStorage.getItem('punchout-sid-key') != null) {
      this.punchOutKey = true;
    }
    this.csAgentAuthSubscription = this.csAgentAuthService.isCustomerEmulated().subscribe((res) => {
      this.isAsmUser = res ? res : false;
    });
    this.punchoutCheckout = localStorage.hasOwnProperty('punchout-sid-key');
    this.localSubscription = this.authService
      .isUserLoggedIn()
      .subscribe((res) => {
        if (sessionStorage.getItem('counter') == null) {
          sessionStorage.setItem('counter', '1');
        } else {
          let temp = Number(sessionStorage.getItem('counter'));
          temp = temp + 1;
          sessionStorage.setItem('counter', String(temp));
        }
      });
    this.authService.logoutInProgress$.subscribe((res) => {
      if (res) {
        this.authService.isUserLoggedIn().subscribe((res) => {
          if (!res) {
            sessionStorage.removeItem('counter');
          }
        });
      }
    });
    this.error_message_dating = "Product may have less than 6 months dating."
    this.globalMessage.remove(GlobalMessageType.MSG_TYPE_ERROR);
    this.plpMiniCartSub = this.plpService
      .getUpdateMiniCart()
      .subscribe((res) => {
        if (res) {
          this.addToCart.removedEntries(res, this.userAccountgetData?.uid);
          this.removeEntriesMapping();
        }
      });
    this.plpService.stdCartMsg.next(false);
    this.baseUrl = this.occEndPoint.getBaseUrl({
      baseUrl: true,
      prefix: false,
      baseSite: false,
    });
    this.pageDate.getCurrentPage().subscribe((res) => {
      if (res) {
        this.templatePage = res?.template;
      }
    });
    this.pageDate.getComponentData("pdfReservationGuideComponent").subscribe(res => {
      let termCondition: any = JSON.parse(JSON.stringify(res));
      this.pdfUrl = this.baseUrl + termCondition?.document?.url;
    })
    this.userDataSub = this.user.get().subscribe((res) => {
      if (res && res != null) {
        this.userAccountgetData = res;

        this.getUserAccountData(this.userAccountgetData.uid);
        // this.addToCart.allCartItems$.subscribe((res1) => {
        //   if (res1) {
        //     this.cartItems = res1?.carts;
        //     this.cartItems = this.cartItems[this.cartItems?.length - 1]
        //     this.cartId = this.cartItems?.code;
        //     if (this.cartItems === undefined) {
        this.productEntries = [];
        //}
        // localStorage.setItem('punchout-sid-key','punchout');
        this.getCartDetails();
        this.cdr.detectChanges();
        // }
        //});
      }
    });
    this.prodAddedSub = this.plpService.stdCartMsg$.subscribe((res) => {
      if (res) {
        this.addSuccess = true;
        this.deleteSuccess = '';
        this.plpService.stdCartMsg.next(false);
      }
    });
    this.setDeliveryDate();
    this.setPickupDate();
  }
  // addemail() {

  //   if (this.emailArr.length <= 3) {
  //     this.emailArr.push(1);
  //     if (this.emailArr.length == 3) {
  //       this.noshowaddemail = true;
  //     }
  //   }

  // }

  addemail() {
    if (this.emailArr.length <= 3) {
      this.emailArr.push({
        id: null,
        value: '',
        iserror: false,
        itemValue: '',
      });
      if (this.emailArr.length == 3) {
        this.noshowaddemail = true;
      }
    }
  }
  updateValidity() {
    this.faxValid = true;
    this.faxErrorMsg = true;
  }
  addnewEmail(event, emailIndex, callingFrom?) {
    if (event == 'Add new email') {
      this.emailArr[emailIndex].id = '-1';
      this.emailArr[emailIndex].value = callingFrom == 'cMethodVal' ? 'Add new email' : '';
    } else {
      this.emailArr[emailIndex].id = '';
      this.emailArr[emailIndex].itemValue = '';
      this.emailArr[emailIndex].value = event;
      this.EmailforContact = event;
      this.emailNullCheckValidation();
    }
  }

  validateEmail(emailID) {
    // var atpos = emailID.indexOf('@');
    // var dotpos = emailID.lastIndexOf('.');
    // if (atpos < 1 || dotpos - atpos < 2) {
    //   return false;
    // } else {
    //   return true;
    // }
    //let val = (/^([A-Za-z0-9\._-]+)@([A-Za-z0-9\._-]+)\.([A-Za-z\.]{2,8})(\.[A-Za-z\.]{2,8})?$/g).test(emailID);
    let val = (/^[\w-\.]+@([\w-]+\.)+[\w-]{2,15}$/g).test(emailID);
    return val;
  }

  addMobile() {
    if (this.mobileList.length <= 3) {
      this.mobileList.push({ value: '', iserror: false });
      if (this.mobileList.length == 3) {
        this.noshowaddmobile = true;
      }
      setTimeout(() => {
        let data = `faxcontactmethod_${this.mobileList.length - 1}`
        document.getElementById(data).focus();
      }, 400);

    }
  }

  emailNullCheckValidation() {
    for (var i = 0; i < this.emailArr.length; i++) {
      if (this.emailArr[i].id == '-1' && this.emailArr[i]["itemValue"] == '') {
        this.emailArr[i].iserror = true;
        this.ErrMsg = "Email field should not be blank"
        return false;
      }
      else if (this.emailArr[i].id == '-1' && this.emailArr[i]["itemValue"] != '') {
        if (!this.validateEmail(this.emailArr[i]["itemValue"])) {
          this.emailArr[i].iserror = true;
          this.ErrMsg = "Please enter a valid email address"
          return false;
        }
        else {
          this.emailArr[i].iserror = false;
          this.ErrMsg = "";
        }
      }
      else if (this.emailArr[i].id != '-1' && this.emailArr[i].value == '') {
        this.emailArr[i].iserror = true;
        this.ErrMsg = "Please select a valid Email address"
        return false;
      }
      else if (this.emailArr[i].id == null && this.emailArr[i].value == '') {
        this.emailArr[i].iserror = true;
        this.ErrMsg = "Please select a valid Email address"
        return false;
      }
      else {
        this.emailArr[i].iserror = false;

      }

    }
    return true;
  }

  poCheck(locSpecificCart) {
    if (locSpecificCart?.poMandatory && locSpecificCart?.POnumber?.trim()?.length == 0) {
      locSpecificCart['poError'] = true;
    }
    else {
      locSpecificCart['poError'] = false;
    }
    this.cdr.detectChanges();
  }

  selectedCardOrAccountDetailsMethod(event) {
    this.selectedCardOrAccountDetails = event;
    //below added so that once new account/card added, it shows the same on screen automatically. Otherwise on manual click or only its working.
    const scrollOptions: ScrollToOptions = {
      top: window.scrollY + 5,
      behavior: 'auto'
    };
    window.scrollTo(scrollOptions);
    this.cdr.detectChanges();
  }
  selectedPaymentMethodDetailsMethod(event) {
    this.selectedPaymentMethodDetails = event;
    this.cdr.detectChanges();
  }

  openmodal(content) {
    //this.selectedLocs = JSON.parse(sessionStorage.getItem('selectedLocations'));
    //this.selectAllChecked = this.selectedLocs && this.selectedLocs.length == this.shippingLocations.length;
    //debugger
    // this.markLocsOnOpenClose();
    let currDate = this.datepipe.transform(new Date(), 'MM/yyyy');
    if ((this.selectedPaymentMethodDetails?.code == 'PAY_BY_CARD' || this.selectedPaymentMethodDetails?.code == "PAY_BY_CREDIT_CARD_3DPRIOR")
      && currDate == this.selectedCardOrAccountDetails.expDate) {
      this.globalMessage.add("Your credit card is expired, please update your card and proceed.",
        GlobalMessageType.MSG_TYPE_ERROR
      );
      return false;
    }

    //Added for PO restriction
    let poerror = false;
    this.stdCartDetails?.forEach((locSpecificCart, index) => {
      if (!this.punchOutKey && locSpecificCart?.poMandatory && locSpecificCart?.POnumber?.trim()?.length == 0) {
        locSpecificCart['poError'] = true;
        poerror = true;
        let poElement = document.getElementById('po_' + index);
        if (poElement) {
          poElement.focus();
        }
        this.cdr.detectChanges();
      }

    });
    if (poerror && !this.punchOutKey) {
      return;
    }
    let orderByError = false;
    if (this.contactDetails?.contactName?.trim()?.length == 0) {
      orderByError = true;
      this.cdr.detectChanges();
    }
    if(this.isAsmUser) {
      if (this.contactDetails?.asmContactName?.trim()?.length == 0) {
        orderByError = true;
        this.orderByErrorMsg = true;
        this.cdr.detectChanges();
      } else {
        this.orderByErrorMsg = false;
      }
    }
    if (orderByError) {
      return;
    }
    this.punchoutCheckout = localStorage.hasOwnProperty('punchout-sid-key');
    if (this.punchoutCheckout) {
      this.punchoutId = localStorage.getItem('punchout-sid-key');
    }
    if (!this.cMethodVal) {
      if (this.contactDetails.contactFax == undefined) {
        this.faxValid = false;
      } else {
        //this.validateFaxNumber(this.contactDetails.contactFax, 'fax');
        this.faxValid = true;
      }
    }
    //For punchout case, the email,fax payment method are not shown to user
    if (!this.punchoutCheckout) {
      if (this.faxValid && this.phoneErrorMsg && this.faxErrorMsg) {
        if (this.selectedPaymentMethodDetails.code == 'PAY_BY_CARD') {
          var cardNumbrArr =
            this.selectedCardOrAccountDetails.cardNumber.split('-');
          this.lastcarddigit = cardNumbrArr[2];
          this.paymentMethod =
            this.selectedPaymentMethodDetails.name +
            ' <br />' +
            '(*' +
            this.lastcarddigit +
            ')';
        }

        else if (this.selectedPaymentMethodDetails.code == "PAY_BY_CHK_ACCOUNT") {
          var cardNumbrArr =
            this.selectedCardOrAccountDetails.cardNumber.split('-');
          this.lastcarddigit = cardNumbrArr[2];
          this.paymentMethod =
            this.selectedPaymentMethodDetails.name +
            ' <br />' +
            '(*Account ending in ' +
            this.lastcarddigit +
            ')';
        }
        else if (this.selectedPaymentMethodDetails.code == "PAY_BY_CREDIT_CARD_3DPRIOR") {
          var cardNumbrArr =
            this.selectedCardOrAccountDetails.cardNumber.split('-');
          this.lastcarddigit = cardNumbrArr[2];
          this.paymentMethod =
            this.selectedPaymentMethodDetails.name +
            '(*' + this.lastcarddigit + ')';
        }
        else if (this.selectedPaymentMethodDetails.code == "PAY_BY_CHK_ACCOUNT_3DPRIOR") {
          var cardNumbrArr =
            this.selectedCardOrAccountDetails.cardNumber.split('-');
          this.lastcarddigit = cardNumbrArr[2];
          this.paymentMethod =
            this.selectedPaymentMethodDetails.name +
            '(*' + this.lastcarddigit + ')';
        }
        else {

          // if(this.selectedPaymentMethodDetails.code=='BILL_ME_LATER'){
          //   this.paymentMethod = "Bill me later";
          // }
          //else {
          this.paymentMethod = this.selectedPaymentMethodDetails.name;
          //}

        }

        if (this.emailNullCheckValidation()) {
          this.modal.open(content, {
            centered: true,
            backdrop: 'static',
            windowClass: `locStripModal ${this.baseSiteId}`,
            // size: 'lg'
          });
        }
      }
    }
    else { //for punchout directly open the modal
      this.modal.open(content, {
        centered: true,
        backdrop: 'static',
        windowClass: `locStripModal ${this.baseSiteId}`,
        // size: 'lg'
      });
    }
  }
  getRequestedDate(dt) {
    if (dt) {
      var formatedDate = dt?.split('T');
      var splitDateF = formatedDate[0].split('-');

      var finalFormatedDate =
        splitDateF[1] + '/' + splitDateF[2] + '/' + splitDateF[0];

      return finalFormatedDate;
    }
  }

  punchoutCheck() {
    if (this.punchoutId) {
      this.addToCart.punchoutCheckout(this.punchoutId);
    }
    this.punchoutCheckoutData = this.addToCart.punchoutCheck.subscribe(data => {
      if (data) {
        // this.buyer_form_post_url = data.browseFormPostUrl;
        // this.xml = data.orderAsCXML;
        // $('#cxml_form').submit();
        // this.cdr.detectChanges();
        let form = $('<form></form>');
        var field = $('<input></input>');
        field.attr("type", "hidden");
        field.attr("name", "cxml-base64");
        field.attr("value", data.orderAsCXML);
        form.append(field);
        // form.setAttribute("cxml-base64", data.orderAsCXML);
        form.attr("method", "post");
        form.attr("action", data.browseFormPostUrl);
        // form.attr("target", '_blank');
        $(document.body).append(form);
        form.submit();
        this.punchoutCheckoutData.unsubscribe();
      }
      // let formData: FormData = new FormData();
      // formData.append('cxml-urlencoded', data.orderAsCXML);
      // $.redirect(data.browseFormPostUrl,
      //   {  
      //     method: 'POST',
      //     body: formData
      //    });
      // });
      // var requestOptions = {
      //   method: 'POST',
      //   body: formData
      // };
      // fetch(data.browseFormPostUrl, requestOptions)
      //   .then(response => response.text())
      //   .then(result => console.log(result))
      //   .catch(error => console.log('error', error));
      // let settings = {
      //   "url": data.browseFormPostUrl,
      //   "method": "POST",
      //   "timeout": 0,
      //   "processData": false,
      //   "mimeType": "multipart/form-data",
      //   "contentType": false,
      //   "data": formData
      // };
      // $.ajax(settings).done(function (response) {
      // });
      // this.http.post(data.browseFormPostUrl, formData).subscribe((res) => {
      // })
    });
  }

  getCartDetails() {
    this.addToCart.checkoutCartDetails$.pipe(filter(res => !!res), take(1)).subscribe(res => {
      if (res?.carts[0]?.hasOwnProperty('cartModifiedMessage') &&
        !!res?.carts[0]?.cartModifiedMessage
      ) {
        if (!this.router?.url?.includes('/orderConfirmation')) {
          this.globalMessage.add(
            this.convertHtmlToPlainTxt(res?.carts[0].cartModifiedMessage[0]),
            GlobalMessageType.MSG_TYPE_ERROR, 5000000
          );
          setTimeout(() => {       
            this.route.goByUrl("/cart");  
          }, 15000);
        }
        
      }
      else {
        this.cartDataMapping(res?.carts[0]);
      }
    });
    this.baseService.get(config.GET_ACCOUNT_ID).subscribe((res) => {
      this.b2b = res?.defaultB2BUnit?.uid;
      this.contactDetailsSub = this.addToCart
        .getOrderContactDetails(this.userAccountgetData.uid, this.b2b)
        .pipe(filter(res => !_.isEmpty(res))).subscribe((res) => {
          if (res.contactEmail) {
            this.emailArr[0].value = res.contactEmail;
            //start: quick fix for USCOMIS-17304
            if(res?.customerEmails?.length === 0) {
              res?.customerEmails.push(res?.contactEmail)
            }
            //end: quick fix for USCOMIS-17304
          }
          this.contactDetails = res;
          if(this.isAsmUser) {
            this.contactDetails.asmContactName = '';
          }
          if (this.contactDetails?.hasOwnProperty('disableFax')) { //if disableFax false, then hide fax option
            if (this.contactDetails?.disableFax) {
              this.showFax = true;
            }
            else {
              this.showFax = false;
            }
          }
          else {
            this.showFax = true;
          }
          this.contactDetails2 = this.contactDetails.contactFax;
          this.emailList = this.contactDetails.customerEmails;
          this.contactDetails.customerEmails.push('Add new email');
          this.cdr.detectChanges();
        });
    });
    if (this.cartId && this.templatePage === 'CartPageTemplate') {
      this.addToCart.removedEntries(this.cartId, this.userAccountgetData?.uid);
      this.removeEntriesMapping();
    }
    this.addToCart.checkoutCartDetails.subscribe((el) => {
      if (el?.carts && el?.carts?.length > 0) {
        this.stdCartDetails = el?.carts[0]?.childCarts;
      }
    });

    if (Array.isArray(this.stdCartDetails)) {
      this.stdCartDetails.forEach(el => {
        this._dataService.addtoDataLayer('begin_checkout', JSON.parse(localStorage.getItem(el.shipToLoc_id + "_forDL")), el.shipToLoc_id, this.stdCartDetails.length);
      })
      this._dataService.addtoDataLayer('clearDataLayer', '', '', '');
    }
    else {
    }
  }

  validateOrderByName(event) {
    if (event?.length === 0) {
      this.orderByErrorMsg = true;
    } else {
      this.orderByErrorMsg = false;
    }
  }
  validateFaxNumber(event, type, i) {
    let newVal;

    // if (fxNmbr == '' || fxNmbr.length != 12) {
    //   this.faxNumberError = true;
    // }
    // else {
    //   this.faxNumberError = false;
    // }
    // this.POnameEdited = true;
    if (event?.length == 12) {
      if (type == 'phone') {
        this.phoneErrorMsg = true;
      }
      if (type == 'mobile') {
        this.mobileList.forEach((el, index) => {
          el.iserror = false;
        })
        this.mobileErrorMsg = true;
      }
      if (type == 'fax') {
        this.faxErrorMsg = true;
      }
      newVal = event?.replace(/\D/g, '');
      if (newVal?.length === 0) {
        newVal = '';
      } else if (newVal?.length <= NumberThree) {
        newVal = newVal?.replace(/^(\d{0,3})/, '$1');
      } else if (newVal?.length <= NumberSix) {
        newVal = newVal?.replace(/^(\d{0,3})(\d{0,3})/, '$1-$2');
      } else if (newVal?.length <= NumberTen) {
        newVal = newVal?.replace(/^(\d{0,3})(\d{0,3})(\d{0,3})/, '$1-$2-$3');
      } else {
        newVal = newVal?.substring(0, NumberTen);
        newVal = newVal?.replace(/^(\d{0,3})(\d{0,3})(\d{0,3})/, '$1-$2-$3');
      }
      if (newVal === '') {
        newVal = null;
      }
      //return newVal;
      // if (type == 'phone') {
      //   this.phoneNo = newVal;
      // }
      // if (type == 'mobile') {
      //   this.mobileNo = newVal;
      // }
      if (type == 'fax') {
        this.contactDetails.contactFax = newVal;
      }
      if (type == 'phone') {
        this.contactDetails.contactPhone = newVal;
      }
      if (type == 'mobile') {
        this.mobileList.forEach(el => {
          if (el.value == event) {
            el.value = newVal;
          }
        })

      }
    }
    else if (event?.length == 0) {
      if (type == 'phone') {
        this.phoneErrorMsg = false;
      }
      if (type == 'mobile') {
        this.mobileErrorMsg = false;
      }
      if (type == 'fax') {
        this.faxErrorMsg = true;
      }
    }
    else {
      if (type == 'phone') {
        this.phoneErrorMsg = false;
      }
      if (type == 'mobile') {
        this.mobileList.forEach((el, index) => {
          if (index == i) {
            el.iserror = true;
          }


        })
        //this.mobileErrorMsg = false;
      }
      if (type == 'fax') {
        this.faxErrorMsg = false;
      }
      if (event === null) {
        return null;
      }
      newVal = event?.replace(/\D/g, '');
      if (newVal?.length === 0) {
        newVal = '';
      } else if (newVal?.length <= NumberThree) {
        newVal = newVal?.replace(/^(\d{0,3})/, '$1');
      } else if (newVal?.length <= NumberSix) {
        newVal = newVal?.replace(/^(\d{0,3})(\d{0,3})/, '$1-$2');
      } else if (newVal?.length <= NumberTen) {
        newVal = newVal?.replace(/^(\d{0,3})(\d{0,3})(\d{0,3})/, '$1-$2-$3');
      } else {
        newVal = newVal?.substring(0, NumberTen);
        newVal = newVal?.replace(/^(\d{0,3})(\d{0,3})(\d{0,3})/, '$1-$2-$3');
      }
      if (newVal === '') {
        newVal = null;
      }
      //return newVal;
      // if (type == 'phone') {
      //   this.phoneNo = newVal;
      // }
      // if (type == 'mobile') {
      //   this.mobileNo = newVal;
      // }
      if (type == 'fax') {
        this.contactDetails.contactFax = newVal;
      }
      if (type == 'phone') {
        this.contactDetails.contactPhone = newVal;
      }
      if (type == 'mobile') {
        this.mobileList.forEach(el => {
          if (el.value == event) {
            el.value = newVal;
          }
        })

      }

    }

  }
  removeEntriesMapping() {
    this.removeEntriesSub = this.addToCart.removedItems$.subscribe(
      (res: any) => {
        if (res) {
          let removedData = res?.removedEntries?.cartModifications;
          let stdCartDetails;
          this.yfEntry = false;
          stdCartDetails = res?.childCarts;
          if (stdCartDetails) {
            stdCartDetails = stdCartDetails.filter(
              (item) => item
              //.cartType === 'STANDARD'
            );
            if (stdCartDetails && stdCartDetails?.length > 0) {
              stdCartDetails = Object.assign({}, ...stdCartDetails);
              for (let entries of stdCartDetails?.entries) {
                if (entries?.product?.yellowFever) {
                  this.yfEntry = true;
                }
              }
            }
          }
          if (!stdCartDetails?.shipToParty?.yellowFeverFlag && this.yfEntry) {
            this.yfEntry = true;
          } else {
            this.yfEntry = false;
            this.globalMessage.remove(GlobalMessageType.MSG_TYPE_ERROR);
          }
          if (removedData && removedData?.length > 0) {
            for (const data of removedData) {
              if (
                !stdCartDetails?.shipToParty?.yellowFeverFlag &&
                this.yfEntry
              ) {
                this.globalMessage.add(
                  this.convertHtmlToPlainTxt(data.statusMessage),
                  GlobalMessageType.MSG_TYPE_ERROR,
                  5000000
                );
              } else {
                this.globalMessage.add(
                  this.convertHtmlToPlainTxt(data.statusMessage),
                  GlobalMessageType.MSG_TYPE_ERROR
                );
              }
            }
          }
          this.addToCart.getAllCarts(this.userAccountgetData?.uid);
          this.addToCart.removedItems.next(false);
        }
      }
    );
  }
  deleteEmail(i) {
    this.emailArr.splice(i, 1);
    if (this.emailArr.length < 3) {
      this.noshowaddemail = false;
    }
  }
  cMethodElection(method) {
    if (method == 'fax') {
      this.cMethodVal = false;
      this.emailArrCopy = [...this.emailArr];
      this.emailArr = [{ id: '', value: 'ns', iserror: false, itemValue: '' }];
    }
    // else {
    //   this.cMethodVal = true;
    //   this.emailArr = [...this.emailArrCopy];
    //   this.emailArrCopy = [];
    // }
    else {
      if (!this.cMethodVal) {
        !this.faxValid ? this.faxValid = true : this.faxValid; //USCOMIS-17304 fix
        this.cMethodVal = true;
        this.emailArr = [...this.emailArrCopy];
        this.emailArrCopy = [];
      }
    }
  }
  deleteMobile(i) {
    this.mobileList.splice(i, 1);
    if (this.mobileList.length < 3) {
      this.noshowaddmobile = false;
    }
  }
  cartDataMapping(data): void {
    //let stdCartDetails = [];
    this.productEntries = [];
    this.cartId = data?.code;

    this.stdCartDetails = data?.childCarts;
    //this.stdCartDetails = JSON.parse(JSON.stringify(tempVariableForresp.carts[0]?.childCarts));
    this.headerLevelObj = this.stdCartDetails.filter((el) => el.hidePriceForTotals);
    this.saveCartName =
      JSON.parse(sessionStorage.getItem('selectedLocations'))?.length <= 1
        ? this.stdCartDetails[0]?.shipToLoc_name
        : '';
    this.stdCartDetails?.forEach((el) => {
      this.totalSavings = 0.0;
      var TotalTaxCal = 0.0;
      el['poError'] = false;    //added for po restriction
      // el['POnumber'] = '';
      el['POnumber'] = el?.purchaseOrderNumber ? el?.purchaseOrderNumber : ''; //binding in case coming in response for upload template 
      el['attention'] = '';
      var locationTot = 0.0;
      var finalDiscount = 0.0;
      el.entries.forEach((ele) => {
        el['quantity'] = ele.quantity;
        //el["ProductSummedPrice"] = el["ProductSummedPrice"] + ele.totalPrice.value;
        locationTot +=
          ele.totalPrice.value + ele.sim_excise_tax.value * ele.quantity;
        el.totalTax.value += ele.exciseTax.value * ele.quantity;
        finalDiscount +=
          ele.webDiscount.value +
          ele.sim_other_discount.value +
          ele.sim_promptpay_Discount.value +
          ele.sim_site_discount.value;
        if (ele.futureShipExpProd && ele.splitEntriesDeliveryDates.length > 0)
          this.isFutershipAdded = true;
      });
      el['futureShipAdded'] = this.isFutershipAdded;
      el['ProductSummedPrice'] = locationTot;
      el['FinalDiscount'] = finalDiscount;
      // var holderVal = el.totalOtherDiscount.formattedValue.split("$");
      // el.totalOtherDiscount.figurevalue = parseFloat(holderVal[1]).toFixed(2);
      // var holderVal2 = el.totalWebDiscount.formattedValue.split("$");
      // el.totalWebDiscount.figurevalue = parseFloat(holderVal2[1]).toFixed(2);

      //this.totalSavings += (el.totalOtherDiscount?.value + el.totalWebDiscount?.value);
      //this.totalSavings += el.totalWebDiscount?.value;
      el.totalWebDiscount.finalDis = parseFloat(this.totalSavings.toFixed(2));
      this.finalSaving += el.FinalDiscount;
      this.shipToArr.push(el?.shipToParty);
    });
    //this.totalSavings = parseFloat(this.totalSavings.toFixed(2));
    this.subTotalVal = 0;
    this.totalWithPromtPayDiscountSum = 0;
    this.stdCartDetails.forEach(el => {
      this.totalSavings = this.totalSavings + el.totalDiscounts?.value;
      this.subTotalVal = this.subTotalVal + el.totalPrice?.value;
      this.totalWithPromtPayDiscountSum = this.totalWithPromtPayDiscountSum + el.totalWithPromptPayDiscount.value;
    })

    this.orderContactDetails = data?.childCarts[0].shipToParty?.billingAddress;
    this.payerAddress = data?.childCarts[0].shipToParty?.payerAddress;
    if (this.stdCartDetails && this.stdCartDetails.length > 0) {
      this.expandedItems = this.stdCartDetails.map(() => false);
    }

    if (this.stdCartDetails) {
      this.stdCartDetails = this.stdCartDetails.filter(
        (item) => item
        //.cartType === 'STANDARD'
      );
      this.standardCartDetails = Object.assign({}, ...this.stdCartDetails);
      for (let cartDetails of this.stdCartDetails) {
        for (let entries of cartDetails.entries) {
          let imagesFormat = _.clone(
            _.findWhere(entries.product?.images, { format: 'cartIcon' })
          );
          if (imagesFormat) imagesFormat.url = this.baseUrl + imagesFormat?.url;
          this.images = { PRIMARY: imagesFormat };
          entries = { ...entries, ...this.images };
          this.productEntries.push(entries);
        }
      }
      if (this.standardCartDetails?.shipToParty) {
        //this.selectedData = this.standardCartDetails?.shipToParty?.shippingAddresses.filter((item) => item.unitID === this.standardCartDetails.shipToParty.uid);
        //this.selectedData = _.first(this.selectedData);
        this.selectedData = this.standardCartDetails?.shipToParty;
      } else {
        if (this.getuserData && this.getuserData?.length > 0) {
          this.selectedData = _.first(
            this.getuserData.filter(
              (item) => item.unitID === this.userAccountgetData?.uid
            )
          );
        }
      }
      //this.saveCartName = this.selectedData?.name?.slice(0, 30);

      this.cdr.detectChanges();
    }
  }
  performQuantityComputation(
    operator,
    idData,
    quantityOfUnits = 1,
    entryNumber,
    childIndex
  ): void {
    const updatedData = String(idData) + '-' + String(childIndex);

    ProductUtils.alterQuantity(operator, updatedData, quantityOfUnits);
    this.updateTotal = true;
    const inputElement = document.getElementById(
      `prodQuantity${updatedData}`
    ) as HTMLInputElement;
    const params = { entryNumber: entryNumber, quantity: inputElement.value };
    if (
      this.updateEntriesData.some(
        ({ entryNumber }) => entryNumber === params.entryNumber
      )
    ) {
      this.updateEntriesData[
        this.updateEntriesData.findIndex(
          (el) => el.entryNumber === params.entryNumber
        )
      ] = params;
    } else {
      this.updateEntriesData = [...this.updateEntriesData, params];
    }
  }
  deleteCart(entryNumber, prodName, childCartIndex): void {
    this.addToCart.deleteCartItem(
      entryNumber,
      this.stdCartDetails[childCartIndex].code,
      this.cartId
    );
    this.deleteCartSub = this.addToCart.deleteItems$.subscribe((res) => {
      if (res) {
        this.addToCart.deleteItems.next(false);
        this.addToCart.removedEntries(
          this.cartId,
          this.userAccountgetData?.uid
        );
        this.removeEntriesMapping();
        this.deleteSuccess = prodName;
        this.addSuccess = false;
      }
    });
  }
  closeAlert() {
    this.deleteSuccess = '';
    this.addSuccess = false;
  }
  closeDangerAlert() {
    this.showDangerAlert = false;
  }
  clearChildCart(): void {
    this.addToCart.clearCart(this.standardCartDetails.code);
  }
  openPopover(popover) {
    popover.open();
  }
  toggleClose() {
    if (this.savePopover) {
      this.savePopover.close();
    }
  }
  toggle(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
    this.errorMsg = '';
    //this.saveCartName = this.selectedData?.name?.slice(0, 30);
  }
  updateCart(): void {
    this.addToCart.updateCartDetails(
      this.standardCartDetails.code,
      this.updateEntriesData,
      this.cartId
    );
    this.cartDetailsSub = this.addToCart.cartDetails$.subscribe((res: any) => {
      if (res) {
        this.updateTotal = false;
        let stdCartDetails = [];
        stdCartDetails = res?.childCarts;
        stdCartDetails = stdCartDetails.filter(
          (item) => item
          //.cartType === 'STANDARD'
        );
        this.standardCartDetails = Object.assign({}, ...stdCartDetails);
        this.updateEntriesData = [];
      }
      this.cdr.detectChanges();
    });
    this.route.goByUrl('/cart');
  }
  productDetails(productDetails, i): void {
    const modalRef = this.modalService.open(ProductDetailsComponent, {
      windowClass: `product-details-modal ${this.baseSiteId}`,
    });
    modalRef.componentInstance.productDetails = productDetails;
    modalRef.componentInstance.standardCartCode = this.stdCartDetails[i].code;
    // modalRef.componentInstance.unitSection = 'Update';
    modalRef.componentInstance.unitSection = 'NoUnitsCheckout';
  }

  onDeliveryDateChange(value: Date): void {
    if (value) {
      this.deliveryCrossIcon = true;
      this.deliveryDateFormat = this.datepipe.transform(value, 'yyyy-MM-dd');
    } else {
      this.deliveryCrossIcon = false;
    }
  }
  onPickupDateChange(value: Date): void {
    if (value) {
      this.pickupCrossIcon = true;
      this.pickupDateFormat = this.datepipe.transform(value, 'yyyy-MM-dd');
      if (value.getDate() !== this.minPickupDate.getDate()) {
        this.timeFormat = this.pickupTimeFormat;
        this.selectedTime = _.first(this.timeFormat);
      } else {
        this.setPickupTime();
      }
    } else {
      this.pickupCrossIcon = false;
    }
  }
  clearDate(dpDate): void {
    if (dpDate === 'Delivery') {
      this.deliveryDate = null;
      this.deliveryCrossIcon = false;
    } else {
      this.pickupDate = null;
      this.pickupCrossIcon = false;
      this.selectedTime = null;
    }
  }
  redirectToCheckout(): void {
    this.route.goByUrl('/checkout');
  }

  proceedtoFinal() {
    this.emailArr.forEach((el) => {
      if (el.id == -1) {
        this.emailFinalArr.push(el.itemValue)
      }
      else {
        this.emailFinalArr.push(el.value);
      }
    });

    this.mobileList.forEach((el) => {
      this.mobFinalArr.push(el.value);
    });
    var arrFororderOtherInfo = [];
    this.stdCartDetails.forEach((el) => {
      var obj = {
        cartId: el.code,
        purchaseOrderNumber: el.POnumber,
        attaintion: el.attention,
        splInstruction: el.instruction,
      };
      arrFororderOtherInfo.push(obj);
    });
    var emailAdditional = [];
    var mobileNoAdditional = [];
    this.emailFinalArr.forEach(function (value, i) {
      if (i != 0) {
        emailAdditional.push(value);
      }
    });

    this.mobFinalArr.forEach(function (value, i) {
      if (i != 0) {
        mobileNoAdditional.push(value);
      }
    });
    this.modal.dismissAll();

    var obj = {
      paymentMethod: this.selectedPaymentMethodDetails.code,
      paymentType:
        this.selectedPaymentMethodDetails.code != 'BILL_ME_LATER'
          ? this.selectedCardOrAccountDetails.paymentType
          : '',
      standardCart: true,
      seasonId: '',
      routingNumber:
        this.selectedPaymentMethodDetails.code != 'BILL_ME_LATER'
          ? this.selectedCardOrAccountDetails.routingNumber
          : '',
      cardType:
        this.selectedPaymentMethodDetails.code != 'BILL_ME_LATER'
          ? this.selectedCardOrAccountDetails.cardType
          : '',
      cardNumber:
        this.selectedPaymentMethodDetails.code != 'BILL_ME_LATER'
          ? this.selectedCardOrAccountDetails.cardNumber
          : '',
      expDate:
        this.selectedPaymentMethodDetails.code != 'BILL_ME_LATER'
          ? this.selectedCardOrAccountDetails.expDate
          : '',
      cardHolderName:
        this.selectedPaymentMethodDetails.code != 'BILL_ME_LATER'
          ? this.selectedCardOrAccountDetails.cardHolderName
          : '',
      orderContact: {

        //name: this.contactDetails.contactName,
        name: !this.isAsmUser ? this.contactDetails.contactName : this.contactDetails.asmContactName,
        email: !this.cMethodVal ? '' : this.emailFinalArr[0],
        emailAdditional: emailAdditional,
        phoneNo: this.contactDetails.contactPhone,
        mobileNo: this.mobFinalArr[0],
        mobileNoAdditional: mobileNoAdditional,
        faxPrefered: !this.cMethodVal ? true : false,
        faxNo: this.cMethodVal ? '' : this.contactDetails.contactFax,
        placedBy: this.contactDetails?.placedBy ? this.contactDetails?.placedBy : this.contactDetails.contactName
      },
      orderOtherInfo: arrFororderOtherInfo,
    };
    //debugger
    this.addToCart.createOrdermethod(
      this.cartId,
      this.userAccountgetData.uid,
      obj
    );
    this.addToCart.placeOrder$.subscribe(
      (placeOrderRes) => {
        if (placeOrderRes) {
          if (
            placeOrderRes?.orders[0]?.placeOrderMessage &&
            placeOrderRes?.orders[0]?.placeOrderMessage?.includes(
              'Error while payment authorization'
            )
          ) {
            // this.globalMessage.add(
            //   'Error while payment authorization during order placement.Please contact helpdesk.',
            //   GlobalMessageType.MSG_TYPE_ERROR
            // );
            this.globalMessage.add(
              'Your payment method has been declined. Please use a different form of payment to complete your transaction.',
              GlobalMessageType.MSG_TYPE_ERROR
            );
            return;
          }
          this.dataLayerAdded(placeOrderRes);
          this.addToCart.getAllCarts(this.userAccountgetData.uid);
          this.sharedService.removeLocalStorage('futureshipModalOpened');
          this.sharedService.removeSessionStorage('tempoData');
          this.sharedService.removeSessionStorage('tempoDataInv');
          this.route.goByUrl('/orderConfirmation');
        }
      },
      (errors) => {
        this.globalMessage.add(
          this.convertHtmlToPlainTxt(errors.message),
          GlobalMessageType.MSG_TYPE_ERROR
        );
      }
    );
  }
  dataLayerAdded(placeOrderRes) {
    let location = JSON.parse(sessionStorage.getItem('selectedLocations'));
    let standardOrders = placeOrderRes?.orders?.filter((item) => item?.cartType == "STANDARD");
    let fluOrders = placeOrderRes?.orders?.filter((item) => item?.cartType !== "STANDARD");
    let standardOrderList = [];
    let fluOrderList = []
    standardOrders?.forEach((element, index) => {
      standardOrderList = [];
      element?.entries?.forEach((entry, index1) => {
        let dataObj = this.dataLayerObjCreation("STANDARD", entry, index1)
        standardOrderList?.push(dataObj);
      });
      if (standardOrderList.length > 0) {
        let obj = {
          orderFullData: element,
          datalayerList: standardOrderList
        }
        this._dataService.addtoDataLayer('purchase', obj, location);
        this._dataService.addtoDataLayer('clearDataLayer', '', '', '');
      }
    });
    fluOrders?.forEach((element, index) => {
      fluOrderList = [];
      element?.entries?.forEach((entry, index1) => {
        let dataObj = this.dataLayerObjCreation("INFLUENZA", entry, index1)
        fluOrderList?.push(dataObj);
      });
      if (fluOrderList.length > 0) {
        let obj = {
          orderFullData: element,
          datalayerList: fluOrderList
        }
        this._dataService.addtoDataLayer('purchase', obj, location);
        this._dataService.addtoDataLayer('clearDataLayer', '', '', '');
      }
    });
  }
  decodeHtmlCharCodes(str) {
    if (str != undefined || str != '') {
      str = str?.replace(/<p>/g, '');
      str = str?.replace(/<\/p>/gm, '');
      str = str?.replace(/&trade;/g, '™');
      str = str?.replace(/&lt/g, '<');
      str = str?.replace(/&gt;/g, '>');
      str = str?.replace(/&nbsp;/g, '');
      str = str?.replace(/"/g, '&quot;');
      str = str?.replace(/'/g, '&#039;');
      str = str?.replace(/<sup>&reg;<\/sup>/g, '®');
      str = str?.replace(/<sup>®<\/sup>/g, '®');
      str = str?.replace(/&reg;/g, '®');
      str = str?.replace(/<sup>&trade;<\/sup>/g, '™');
      str = str?.replace(/<sup>™<\/sup>/g, '™');
      str = str?.replace(/<span>/g, '');
      str = str?.replace(/<\/span>/gm, '');
      str = str?.replace(/\n/g, '');
      str = str?.replace(/<br>/g, '');
      str = str?.replace(/&nbsp/g, ' ');
      return str;
    }
  }
  dataLayerObjCreation(cartType, element, index) {
    let dataObj = {
      item_id: element?.product?.code,
      item_name: this.decodeHtmlCharCodes(element?.product?.name),
      affiliation: cartType == "STANDARD" ? "order products" : "influenza products",
      currency: "USD",
      discount: "0",
      index: index,
      item_brand: element?.product?.manufacturer,
      item_category: element?.product?.baseProductInfo?.baseProductDescription,
      item_category2: "",
      item_variant: this.decodeHtmlCharCodes(element?.product?.variantProductDescription),
      price: element?.basePrice?.value,
      quantity: element?.quantity
    }
    return dataObj
  }

  continueDisableCheck() {
    if (this.punchoutCheckout) { //since for punchout, no payment details are required.
      return false;
    }
    if (this.selectedPaymentMethodDetails?.code) {
      //some payment method is selected
      if (
        this.selectedPaymentMethodDetails?.code != 'BILL_ME_LATER' &&
        (this.selectedCardOrAccountDetails?.cardType == undefined ||
          this.selectedCardOrAccountDetails?.cardType == '')
      ) {
        //other methods with card/acc
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  proceedToCheckout(): void {
    if (
      this.deliveryDateFormat ||
      (this.pickupDateFormat && this.selectedTime)
    ) {
      const params = {
        customerId: this.usergetDataObj.uid,
        date:
          this.deliveryPickup === 'delivery' &&
            (this.deliveryDateFormat || this.pickupDateFormat)
            ? this.deliveryDateFormat
            : this.pickupDateFormat,
        deliveryMode:
          this.deliveryPickup === 'delivery' ? 'standard' : 'pickup',
        pickupTime:
          this.deliveryPickup === 'pickup' && this.selectedTime
            ? this.selectedTime
            : '',
        shipToUnitId: this.selectedData?.uid,
        standard: true,
      };
      this.addToCart.checkoutCart(params, this.cartId);
      this.checkoutClicked = true;
      this.checkoutDetailsSub = this.addToCart.checkoutDetails$.subscribe(
        (res) => {
          if (res) {
            this.checkoutClicked = false;
            this.route.goByUrl('/checkout');
          }
        }
      );
      this.checkoutFailedSub = this.addToCart.checkoutFailed$.subscribe(
        (res) => {
          if (res) {
            this.checkoutClicked = false;
          }
        }
      );
    }
  }

  proceedToCheckoutPage() {
    const params = {
      b2bUnitId: this.b2bUnitId,
    };
    this.addToCart.checkoutCartPage(params, this.cartId);
    this.checkoutCartClicked = true;
    this.checkoutCartDetailsSub = this.addToCart.checkoutCartDetails$.subscribe(
      (res) => {
        if (res) {
          this.checkoutCartClicked = false;
          this.route.goByUrl('/checkout');
        }
      }
    );
    this.checkoutCartFailedSub = this.addToCart.checkoutCartFailed$.subscribe(
      (res) => {
        if (res) {
          this.checkoutCartClicked = false;
        }
      }
    );
  }

  open(content): void {
    this.searchedClientList = this.getuserData;
    this.modalService
      .open(content, { ariaLabelledBy: 'modal-basic-title' })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  getUserAccountData(userId): void {
    this.userAccountDetailsSub = this.addToCart.userAccountDetails$.subscribe(
      (userDataget) => {
        if (userDataget) {
          this.usergetDataObj = userDataget.res;
          this.getuserData = userDataget.res.shippingAddresses;
          this.searchedClientList = userDataget.res.shippingAddresses;
          this.b2bUnitId = userDataget?.res?.uid;
          this.orderBlock = userDataget?.res?.orderBlockFlag ? true : false;
          if (this.orderBlock) {
            this.showDangerAlert = true;
          }
          this.changeLocation = this.getuserData?.length <= 1 ? false : true;
          this.cdr.detectChanges();
        }
      }
    );
  }

  onOptionsSelected(data) {
    this.listSelectedData = data;
  }

  onSubmit(): void {
    if (this.listSelectedData != undefined) {
      this.selectedData = this.listSelectedData;
      this.addToCart.saveLocation(
        this.selectedData?.uid,
        this.cartId,
        this.userAccountgetData?.uid
      );
      this.changedLocSub = this.addToCart.changedLocation$.subscribe((res) => {
        if (res) {
          this.addToCart.removedEntries(
            this.cartId,
            this.userAccountgetData?.uid
          );
          this.removeEntriesMapping();
        }
      });
    }
  }
  SearchClientName(data: any) {
    if (data.length > 0) {
      this.searchedClientList = this.getuserData.filter(
        (x) =>
          (x.companyName != undefined &&
            x.companyName.toLowerCase().indexOf(data.toLowerCase()) >= 0) ||
          (x.unitID != undefined &&
            x.unitID.toLowerCase().indexOf(data.toLowerCase()) >= 0) ||
          (x.line1 != undefined &&
            x.line1.toLowerCase().indexOf(data.toLowerCase()) >= 0) ||
          (x.line2 != undefined &&
            x.line2.toLowerCase().indexOf(data.toLowerCase()) >= 0) ||
          (x.town != undefined &&
            x.town.toLowerCase().indexOf(data.toLowerCase()) >= 0) ||
          (x.postalCode != undefined &&
            x.postalCode.toLowerCase().indexOf(data.toLowerCase()) >= 0)
      );
    } else {
      this.searchedClientList = this.getuserData;
    }
  }
  saveOrder(): void {
    var reg = /^[^`!@#~$%\^&*()_+\-={};':"\\|[\]\\.,<>/\/?~]*$/;
    if (this.saveCartName && RegExp(reg).test(this.saveCartName)) {
      this.addToCart.saveCartDetails(this.saveCartName, this.cartId, true);
      this.saveCartInvalidSub = this.addToCart.invalidCartName$.subscribe(
        (res) => {
          if (res) {
            for (let error of res?.error?.errors) {
              this.errorMsg = error?.message;
            }
          }
        }
      );
      this.saveCartSuccessSub = this.addToCart.saveCartSuccess$.subscribe(
        (res) => {
          if (res) {
            if (this.savePopover) {
              this.savePopover.close();
            }
            this.errorMsg = '';
            this.saveCartName = this.selectedData?.name?.slice(0, 30);
          }
        }
      );
    } else {
      if (this.saveCartName) {
        this.errorMsg = 'Save cart name is not valid.';
      } else {
        this.errorMsg = 'Cart name cannot be blank.';
      }
    }
  }
  exportXls() {
    let cartProducts = [];
    for (let cartItem of this.stdCartDetails) {
      for (let entries of cartItem.entries) {
        cartProducts.push({
          Customer: cartItem.shipToLoc_id + ' ' + cartItem.shipToLoc_name,
          Material: entries?.product?.code,
          Quantity: entries?.quantity,
        });
      }
    }
    this.addToCart.downloadXls(cartProducts, 'Checkout');
  }
  omit_special_char(event) {
    this.errorMsg = '';
    var reg = /^[^`!@#~$%\^&*()_+\-={};':"\\|[\]\\.,<>/\/?~]*$/;
    return new RegExp(reg).test(event.key);
  }
  setDeliveryDate() {
    this.minDeliveryDate.setDate(this.minDeliveryDate.getDate());
    if (
      this.minDeliveryDate.getDay() === 0 ||
      this.minDeliveryDate.getDay() === 6
    ) {
      for (let i = 1; i <= 3; i++) {
        this.minDeliveryDate.setDate(this.minDeliveryDate.getDate() + 1);
        if (
          this.minDeliveryDate.getDay() !== 0 &&
          this.minDeliveryDate.getDay() !== 6
        )
          break;
      }
    }
    this.maxDeliveryDate.setDate(this.minDeliveryDate.getDate() + 6);

    this.deliveryDate = this.minDeliveryDate;
  }
  setPickupDate() {
    if (this.currentTime < 12) {
      // Date Set
      this.minPickupDate.setDate(this.minPickupDate.getDate());
      if (
        this.minPickupDate.getDay() === 0 ||
        this.minPickupDate.getDay() === 6
      ) {
        for (let i = 1; i <= 3; i++) {
          this.minPickupDate.setDate(this.minPickupDate.getDate() + 1);
          if (
            this.minPickupDate.getDay() !== 0 &&
            this.minPickupDate.getDay() !== 6
          )
            break;
        }
      }
      this.maxPickupDate.setDate(this.minPickupDate.getDate() + 6);
    } else {
      this.minPickupDate.setDate(this.minPickupDate.getDate() + 1);
      if (
        this.minPickupDate.getDay() === 0 ||
        this.minPickupDate.getDay() === 6
      ) {
        for (let i = 1; i <= 3; i++) {
          this.minPickupDate.setDate(this.minPickupDate.getDate() + 1);
          if (
            this.minPickupDate.getDay() !== 0 &&
            this.minPickupDate.getDay() !== 6
          )
            break;
        }
      }
      this.maxPickupDate.setDate(this.minPickupDate.getDate() + 6);
    }
    this.pickupDate = this.minPickupDate;
  }
  setPickupTime() {
    if (this.currentTime < 10) {
      this.timeFormat = this.pickupTimeFormat.slice(3);
    } else if (this.currentTime === 10) {
      this.timeFormat = this.pickupTimeFormat.slice(4);
    } else if (this.currentTime === 11) {
      this.timeFormat = this.pickupTimeFormat.slice(6);
    } else if (this.currentTime > 11 && this.currentTime < 17) {
      this.timeFormat = this.pickupTimeFormat.slice(0);
    } else if (this.currentTime > 16) {
      this.timeFormat = this.pickupTimeFormat.slice(3);
    }
    this.selectedTime = _.first(this.timeFormat);
  }
  toggleAccordion(index: number) {
    this.expandedItems[index] = !this.expandedItems[index];
  }
  getExpandedItems(index: number): boolean {
    return this.expandedItems[index] || false;
  }
  getImage(images: any, imgFormat: string) {
    'thumbnail';
    const imagesFormat = _.clone(_.findWhere(images, { format: imgFormat }));
    let finalImageUrl: string;
    if (imagesFormat) {
      finalImageUrl = `${this.baseUrl}${imagesFormat?.url}`;
    } else {
      if (this.baseSiteId == 'vsh') {
        finalImageUrl = '../../assets/i18n-assets/sanofi_missing_product.jpg'
      } else {
        finalImageUrl = '../../assets/i18n-assets/sanofi_missing_product_vax.jpg'
      }
      //finalImageUrl = this.fallbackImage;
    }
    return finalImageUrl;
  }
  getTotalPrice(childCarts) {
    let totalPrice = 0;
    if (childCarts) {
      for (const carts of childCarts) {
        for (const entries of carts?.entries) {
          totalPrice += entries?.totalPrice.value;
        }
      }
    }
    return totalPrice;
  }

  getTotalPriceCalc(childCarts) {
    let totalPrice = 0;
    let totalDiscount = 0;
    if (childCarts) {
      for (const carts of childCarts) {
        //for (const entries of carts?.entries) {

        carts.entries.forEach((ele) => {
          totalPrice +=
            ele?.totalPrice?.value + ele?.sim_excise_tax.value * ele?.quantity;
          totalDiscount +=
            ele?.sim_other_discount?.value +
            ele?.sim_promptpay_Discount?.value +
            ele?.sim_site_discount?.value +
            ele?.webDiscount?.value;
        });
      }
    }
    return totalPrice + totalDiscount;
  }

  getQuantity(childCarts) {
    let quantity = 0;
    if (childCarts) {
      for (const entries of childCarts) {
        for (const item of entries.entries) {
          quantity += item?.quantity;
        }
      }
    }
    return quantity;
  }

  ngOnDestroy() {
    this.prodAddedSub?.unsubscribe();
    this.cartItemsSub?.unsubscribe();
    this.removeEntriesSub?.unsubscribe();
    this.deleteCartSub?.unsubscribe();
    this.cartDetailsSub?.unsubscribe();
    this.checkoutDetailsSub?.unsubscribe();
    this.checkoutFailedSub?.unsubscribe();
    this.userAccountDetailsSub?.unsubscribe();
    this.changedLocSub?.unsubscribe();
    this.saveCartInvalidSub?.unsubscribe();
    this.saveCartSuccessSub?.unsubscribe();
    this.plpMiniCartSub?.unsubscribe();
    this.userDataSub?.unsubscribe();
    this.globalMessage.remove(GlobalMessageType.MSG_TYPE_ERROR);
    this.localSubscription.unsubscribe();
    this.checkoutCartDetailsSub?.unsubscribe();
    this.checkoutCartFailedSub?.unsubscribe();
    this.cartProdDetails?.unsubscribe();
  }
  stdFluDesc(productentry) {
    // return (productentry?.product?.variantOptions.length > 0 &&
    //   productentry?.product?.variantOptions[0]?.flu &&
    //   productentry?.product?.variantOptions[0]?.shipNow == 'ON') ||
    //   (productentry?.product?.variantOptions.length == 0 &&
    //     productentry?.product?.flu &&
    //     productentry?.product?.shipNow == 'ON')
    //   ? 'Influenza Vaccine'
    //   : productentry?.product?.description;
    return productentry?.product?.description;
  }
  navigateToPdp() {
    this.route.goByUrl('/Open-Catalogue/c/1');
  }
  isWeekDate(date): string {
    let shipImmediateFormat = moment.utc((new Date(date))).format('MM/DD/yyyy') + '<br>(Estimated)';
    let weekOfFormat = 'Week of\n' + moment.utc(new Date(date)).format('MM/DD/yyyy');
    if (localStorage.hasOwnProperty('shipImmediateDateFS') && localStorage.getItem('shipImmediateDateFS')) {
      if (moment.utc(new Date(date)).format('DD/MM/yyyy') == moment.utc(new Date(localStorage.getItem('shipImmediateDateFS'))).format('DD/MM/yyyy'))
        return shipImmediateFormat
      else
        return weekOfFormat;
    }
    else {
      return weekOfFormat;
    }
  }

  getQtyOrShipDate(index, date, quantityVal, action) {
    if (action === 'quantity') {
      if (index === 0) {
        return quantityVal;
      } else {
        return this.isWeekDate(date);
      }
    }
    else {
      if (index === 0) {
        return this.isWeekDate(date);
      }
      else {
        return '';
      }
    }
  }
  convertHtmlToPlainTxt(html){
    var tempDivElement = document.createElement("div");
    tempDivElement.innerHTML = html;
    return tempDivElement.textContent || tempDivElement.innerText || "";
  }

}
